import Link from 'next/link'
import { AppLinkProps } from './AppLink.types'

export default function AppLink({
  children,
  href,
  external,
  target,
  className,
}: AppLinkProps) {
  return external ? (
    <a className={className} href={href || '#'} target={target || '_self'}>
      {children}
    </a>
  ) : (
    <Link href={href || '#'} passHref>
      <a className={className}>{children}</a>
    </Link>
  )
}
